import { helper } from '@ember/component/helper';

const typeOfHelper = helper(([value]: [unknown] /*, hash*/) => {
  return typeof value;
});

export default typeOfHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    typeof: typeof typeOfHelper;
  }
}
